import { OptionsIcon } from "assets/icons/OptionsIcon";
import { ModalDelete } from "components/ModalDelete/ModalDelete";
import { TituloI } from "interfaces/Titulo";
import { ValidezNacionalI } from "interfaces/ValidezNacionalI";
import { ReactNode, useState } from "react";
import { Badge, Dropdown } from "react-bootstrap";
import { formatDate } from "utils/formatUtils";

interface Props {
  elemento: ValidezNacionalI;
  renderActions?: (elemento: ValidezNacionalI) => ReactNode;
}

export const ValidezNacionalRow = ({ elemento, renderActions }: Props) => {
  return (
    <>
      <tr className="table-row" key={`ResolucionTable-${elemento.id}`}>
        <td>{elemento?.id}</td>
        {/* <td>{elemento?.nombre}</td> */}
        <td>
          {elemento.fechaAprobacion
            ? formatDate.stringDate(elemento?.fechaAprobacion)
            : ""}
        </td>
        <td>
          {elemento.fechaCaducidad
            ? formatDate.stringDate(elemento?.fechaCaducidad)
            : ""}
        </td>
        <td>{elemento?.planEstudio?.nombre}</td>
        <td>{elemento?.normativa?.nombre}</td>
        <td>
          <Badge
            bg={"none"}
            style={{
              color: `${elemento?.estado?.textColor}`,
              backgroundColor: `${elemento?.estado?.backgroundColor}`,
              borderColor: `${elemento?.estado?.borderColor}`,
            }}
          >
            {elemento?.estado?.nombre}
          </Badge>
        </td>
        {/* <td>{elemento?.expedienteInterno}</td>
        <td>{elemento?.expedienteNacional}</td> */}
        {renderActions && (
          <td style={{ maxWidth: "50px" }}>{renderActions(elemento)}</td>
        )}
      </tr>
    </>
  );
};
